import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ArrowLongLeftSvgComponent } from '@uc/shared/svg';
import { CourseSearchPathService } from '@uc/web/core';
import { Router } from '@angular/router';

@Component({
	selector: 'uc-back-to-all-courses-btn',
	templateUrl: './back-to-all-courses-btn.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [ArrowLongLeftSvgComponent],
})
export class BackToAllCoursesBtnComponent {
	constructor(
		private _router: Router,
		private _courseSearchPathSrv: CourseSearchPathService,
	) {}

	onNavigateBack() {
		const path = this._courseSearchPathSrv.path();
		this._router.navigateByUrl(path ?? '');
	}
}
